import { JSX } from "react";
import { Navigate } from "react-router-dom";

const isAuthenticated = () => {
    return !!sessionStorage.getItem("token"); // or use context/state
};

const PrivateRoute = ({ children }: { children: JSX.Element }) => {
    return isAuthenticated() ? children : <Navigate to="/login" />;
};

export default PrivateRoute;
